import type {PricingFeatures} from "./pricing-comparison-types";

import {TiersEnum} from "./pricing-types";

const features: PricingFeatures = [
  {
    title: "月消息收发量",
    items: [
      {
        title: "月消息收发量",
        tiers: {
          [TiersEnum.Startup]: "1,000",
          [TiersEnum.Free]: "6,000",
          [TiersEnum.Pro]: "20,000",
          [TiersEnum.Team]: "50,000",
          [TiersEnum.Customer]: "100,000+",
        },
      },
    ],
  },
  {
    title: "基础能力",
    items: [
      {
        title: "聚合收件箱",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "智能体",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "访客列表",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "消息统计",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "固定话术",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "沙盒",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "账号授权",
        tiers: {
          [TiersEnum.Startup]: "2",
          [TiersEnum.Free]: "不限",
          [TiersEnum.Pro]: "不限",
          [TiersEnum.Team]: "不限",
          [TiersEnum.Customer]: "不限",
        },
      },
      {
        title: "测试集",
        tiers: {
          [TiersEnum.Startup]: "50",
          [TiersEnum.Free]: "不限",
          [TiersEnum.Pro]: "不限",
          [TiersEnum.Team]: "不限",
          [TiersEnum.Customer]: "不限",
        },
      },
      {
        title: "知识单元",
        tiers: {
          [TiersEnum.Startup]: "10",
          [TiersEnum.Free]: "50",
          [TiersEnum.Pro]: "500",
          [TiersEnum.Team]: "5,000",
          [TiersEnum.Customer]: "不限",
        },
        helpText:
          "知识单元是 AI理解和使用知识的基本单位，一个网页或一份文档内容都会被转换为知识单元。",
      },
      {
        title: "AI 技能",
        tiers: {
          [TiersEnum.Startup]: "最多5个",
          [TiersEnum.Free]: "不限",
          [TiersEnum.Pro]: "不限",
          [TiersEnum.Team]: "不限",
          [TiersEnum.Customer]: "不限",
        },
      },
      {
        title: "Webhook",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "API 访问",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "用户与组织管理",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "AI介入策略",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "多语言",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "图片识别",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "数据保存时长",
        tiers: {
          [TiersEnum.Startup]: "90天",
          [TiersEnum.Free]: "6个月",
          [TiersEnum.Pro]: "12个月",
          [TiersEnum.Team]: "不限",
          [TiersEnum.Customer]: "自定义",
        },
      },
      {
        title: "联网检索",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: false,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "文件识别",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: false,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
    ],
  },
  {
    title: "进阶能力",
    items: [
      {
        title: "自定义应用开发",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: "最多3个",
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "🔥MCP",
        tiers: {
          [TiersEnum.Startup]: "最多5个",
          [TiersEnum.Free]: "不限",
          [TiersEnum.Pro]: "不限",
          [TiersEnum.Team]: "不限",
          [TiersEnum.Customer]: "不限",
        },
      },
      {
        title: "自定义流量包",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: false,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
    ],
  },
  {
    title: "个性化能力",
    items: [
      {
        title: "智能体头像",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "空间品牌",
        tiers: {
          [TiersEnum.Startup]: "3Chat.ai",
          [TiersEnum.Free]: "自定义",
          [TiersEnum.Pro]: "自定义",
          [TiersEnum.Team]: "自定义",
          [TiersEnum.Customer]: "自定义",
        },
      },
      {
        title: "聊天脚标",
        tiers: {
          [TiersEnum.Startup]: "3Chat.ai",
          [TiersEnum.Free]: "3Chat.ai",
          [TiersEnum.Pro]: "自定义",
          [TiersEnum.Team]: "自定义",
          [TiersEnum.Customer]: "自定义",
        },
      },
    ],
  },
  {
    title: "渠道",
    items: [
      {
        title: "官网聊天插件",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "邮件渠道",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "微信客服",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "微信小店",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "微信服务号",
        tiers: {
          [TiersEnum.Startup]: true,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "🔥个V号",
        tiers: {
          [TiersEnum.Startup]: "¥98/月/个",
          [TiersEnum.Free]: "¥98/月/个",
          [TiersEnum.Pro]: "¥98/月/个",
          [TiersEnum.Team]: "¥98/月/个",
          [TiersEnum.Customer]: "¥98/月/个",
        },
      },
      {
        title: "🔥企业微信渠道",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: "¥1,500/年/个",
          [TiersEnum.Team]: "¥1,500/年/个",
          [TiersEnum.Customer]: "¥1,500/年/个",
        },
      },
      {
        title: "🔥小红书渠道",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: "¥1,500/年/个",
          [TiersEnum.Pro]: "¥1,500/年/个",
          [TiersEnum.Team]: "¥1,500/年/个",
          [TiersEnum.Customer]: "¥1,500/年/个",
        },
      },
      {
        title: "抖音私信(Beta)",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: "¥1,500/年/个",
          [TiersEnum.Pro]: "¥1,500/年/个",
          [TiersEnum.Team]: "¥1,500/年/个",
          [TiersEnum.Customer]: "¥1,500/年/个",
        },
      },
      {
        title: "🔥WhatsApp",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "Instagram",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "Facebook",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: true,
          [TiersEnum.Pro]: true,
          [TiersEnum.Team]: true,
          [TiersEnum.Customer]: true,
        },
      },
      {
        title: "电商平台支持",
        tiers: {
          [TiersEnum.Startup]: "3ChatClaw",
          [TiersEnum.Free]: "3ChatClaw",
          [TiersEnum.Pro]: "3ChatClaw",
          [TiersEnum.Team]: "3ChatClaw",
          [TiersEnum.Customer]: "3ChatClaw",
        },
        helpText:
          "目前支持小红书店铺，抖音店铺，淘宝，拼多多，京东，1688，闲鱼和美团点评。需要同时购买3ChatClaw产品实现。",
      },
    ],
  },
  {
    title: "服务",
    items: [
      {
        title: "售后支持",
        tiers: {
          [TiersEnum.Startup]: "社区论坛",
          [TiersEnum.Free]: "社区论坛",
          [TiersEnum.Pro]: "客户成功",
          [TiersEnum.Team]: "专属服务群",
          [TiersEnum.Customer]: "VIP专家服务",
        },
      },
      {
        title: "首次购买赠送交付工时权益",
        tiers: {
          [TiersEnum.Startup]: false,
          [TiersEnum.Free]: false,
          [TiersEnum.Pro]: "16h",
          [TiersEnum.Team]: "40h",
          [TiersEnum.Customer]: "个性化方案",
        },
      },
    ],
  },
];

export default features;
